import { render } from "./NumberUsageModal.vue?vue&type=template&id=92ddc350"
import script from "./NumberUsageModal.vue?vue&type=script&lang=js"
export * from "./NumberUsageModal.vue?vue&type=script&lang=js"

import "./NumberUsageModal.vue?vue&type=style&index=0&id=92ddc350&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__